import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ICourseSessionResponse } from "./types";

import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetApi } from "@api/util/createGetApi";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<
      Omit<ICourseSessionResponse, "course">,
      ICourseSessionResponse["course"]
    >
  >,
  IPathBaseParam,
  IPaginationParams
>("courses.sessions");
const getApis = createGetApi<
  IApiResponse<ICourseSessionResponse>,
  IPathByIdParam,
  object
>("courses.sessions");

export const sessions = {
  ...getAllApis,
  ...getApis,
};
